__turbopack_context__.v({
  "heading": "cms-text-block-module__S25P_W__heading",
  "headingLine": "cms-text-block-module__S25P_W__headingLine",
  "subheading": "cms-text-block-module__S25P_W__subheading",
  "subheadingLine": "cms-text-block-module__S25P_W__subheadingLine",
  "wrapper": "cms-text-block-module__S25P_W__wrapper",
});
